import { render, staticRenderFns } from "./dashboard-filters.vue?vue&type=template&id=5cc579c1&scoped=true&"
import script from "./dashboard-filters.vue?vue&type=script&lang=js&"
export * from "./dashboard-filters.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-filters.vue?vue&type=style&index=0&id=5cc579c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc579c1",
  null
  
)

export default component.exports